import { BonusTypeEnum } from '../Models/Game/BonusModel';

export default [
    {
        type: BonusTypeEnum.clock,
        rooms: [1, 3, 6, 10, 22],
        props: {
            freezeTime: [5, 10],
        },
        text: 'Ненадолго останавливает время всех заданий.',
    },
    {
        type: BonusTypeEnum.tea,
        rooms: [6, 15, 22, 24, 20],
        props: {
            addingTime: 15,
        },
        text: '+15 секунд свободного времени.',
    },
    {
        type: BonusTypeEnum.eraser,
        rooms: [3, 5, 28, 10, 18],
        props: {
            eraseCount: 2,
        },
        text: 'Меняет 2 самых срочных задания на новые.',
    },
    {
        type: BonusTypeEnum.transform,
        rooms: [1, 5, 13, 18, 20],
        props: {
            speedAddingPercent: 30,
            speedAddingTime: 20,
        },
        text: 'Скорость перемещения +30% на 20 секунд.',
    },
    {
        type: BonusTypeEnum.calculator,
        rooms: [3, 8, 6, 28, 13],
        props: {
            scoreMultiplier: 2,
        },
        text: '+100% очков за следующее задание.',
    },
    {
        type: BonusTypeEnum.teleport,
        rooms: [11, 10, 22, 24, 20],
        props: {},
        text: 'Переносит к самому срочному заданию.',
    },
    {
        type: BonusTypeEnum.logo,
        rooms: [8, 28, 15, 18],
        props: {
            speedAddingPercent: 20,
            speedAddingTime: 20,
            addingScore: 100,
        },
        text: '+100 победных очков, +20% к скорости на 20 секунд.\n' +
            'Убирает все активные задания и сбрасывает таймеры.',
    },
    {
        type: BonusTypeEnum.money,
        rooms: [1, 8, 13, 15, 20],
        props: {
            probability: 50,
        },
        text: '-50% победных очков за следующее задание.',
    },
];
